import { add, isAfter, isBefore, isEqual } from 'date-fns';

import { environment as ENV } from '@environment';
import { toDateUtc } from '@ux/mappers/date.mapper';

export class TzDatesHelper {

  private readonly locale = 'en-US';
  private readonly timeZone = ENV.countryInfo.tzIdentifier;

  constructor() { }

  public isTodayBetweenTwoDates(startDate: string, endDate: string): boolean {
    const start = toDateUtc(startDate);
    const end = toDateUtc(endDate);
    const today = new Date(new Date().toLocaleString(this.locale, { timeZone: this.timeZone }));
    return (isAfter(today, start) || isEqual(today, start)) && (isBefore(today, end) || isEqual(today, end));
  }

  public isDateAfterToday(date: string): boolean {
    const utcDate = toDateUtc(date);
    const today = new Date(new Date().toLocaleString(this.locale, { timeZone: this.timeZone }));
    const endDate = add(utcDate, { hours: 12, minutes: 0, seconds: 0 });
    return isAfter(endDate, today) || isEqual(endDate, today);
  }

  public isDateBeforeToday(date: string): boolean {
    const utcDate = toDateUtc(date);
    const today = new Date(new Date().toLocaleString(this.locale, { timeZone: this.timeZone }));
    const endDate = add(utcDate, { hours: 12, minutes: 0, seconds: 0 });
    return isBefore(endDate, today);
  }

}
